import { createClient } from '@supabase/supabase-js'

const projectUrl = 'https://bqkzdkbmhypkdthaetma.supabase.co'
const anonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJxa3pka2JtaHlwa2R0aGFldG1hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTIzMDk3NzQsImV4cCI6MjAyNzg4NTc3NH0.XE1Hkb7C-1mA15HPlEIGULU474ke-0rjteSAiZRjrCk'

export const supabase = createClient(projectUrl, anonKey)
